<template>
    <div class="modal-window mbs010">
        <header class="modal-header">
            <div class="tit" v-show="type === 'TERMS'">{{ $i18nUtil.trans("title.UseTerms.001","이용약관") }}</div>
            <div class="tit" v-show="type === 'PRIVACY' && $i18nUtil.getLanguage() === 'ko'">{{ $i18nUtil.trans("title.PrivacyPolicy.001","개인정보 취급방침") }}</div>
            <!-- <button @click="$emit('close')" class="btn_close">닫기</button> -->
        </header>
        <div class="modal-content">
            <div class="tab_ty2" id="tabsTy1">
                <div class="tab-content">
                    <UseTerms v-show="type === 'TERMS'"/>
                    <PrivacyPolicy v-show="type === 'PRIVACY' && $i18nUtil.getLanguage() === 'ko'"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UseTerms from "@/components/cowork/join/modal/UseTerms";
import PrivacyPolicy from "@/components/cowork/join/modal/PrivacyPolicy";
export default {
    // props : {
    //     modalInfo: {
    //         type: Object,
    //         required: true,
    //     },
    // },
    data() {
        return {
            type : null
        }
    },
    mounted() {
        this.type = this.$route.params.type
        document.querySelector('body').classList.add('terms');
    },
    components : {
        UseTerms,
        PrivacyPolicy
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/FooterCotentModal.vue